import axios from "axios";
import { SessionStore } from "../../types/store";
import { newAbortSignal } from "../../utils";
import { VariableResponse } from "../../types/model/variable";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/reference-values/variables`;

export const getVariables = async (
  includeDisabled: boolean = false,
  categories?: string[],
): Promise<VariableResponse[]> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  return await axios
    .get<VariableResponse[]>(BASE_URL, {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
      params: {
        disabled: includeDisabled,
        ...(categories && categories.length > 0 ? { category: categories } : {}),
      },
    })
    .then((response) => response.data);
};
